import React from 'react';
import DashboardV2MiniCard from './DashboardV2MiniCard';
import DashboardV2VendeurLabel from './DashboardV2VendeurLabel';
import { formatDashboardNumber, formatDashboardCa, getRowLineClass } from '../../../utils/dashboardV2Utils';

const DashboardV2PipeRows = ({ rows = [], colorByName = {} }) => {
  if (!rows.length) {
    return <div className="p-3 text-muted">Aucune donnée disponible.</div>;
  }

  return rows.map((row, idx) => (
    <div key={`${row.vendeur}-${idx}`} className={`v2-row-line ${getRowLineClass(row)}`}>
      <DashboardV2VendeurLabel vendeur={row.vendeur} rowType={row._row_type} colorByName={colorByName} />
      <div className="v2-cards-grid cols-8">
        <div className="v2-pair">
          <DashboardV2MiniCard label="Koikispass NB" value={formatDashboardNumber(row.koikispass_nb)} bgClass="v2-bg-koikispass" />
          <DashboardV2MiniCard label="Koikispass CA" value={formatDashboardCa(row.koikispass_ca)} bgClass="v2-bg-koikispass" />
        </div>
        <div className="v2-pair">
          <DashboardV2MiniCard label="itiConseil NB" value={formatDashboardNumber(row.iticonseil_nb)} bgClass="v2-bg-iticonseil" />
          <DashboardV2MiniCard label="itiConseil CA" value={formatDashboardCa(row.iticonseil_ca)} bgClass="v2-bg-iticonseil" />
        </div>
        <div className="v2-pair">
          <DashboardV2MiniCard label="Mixtes NB" value={formatDashboardNumber(row.mixte_nb)} bgClass="v2-bg-mixte" />
          <DashboardV2MiniCard label="Mixtes CA" value={formatDashboardCa(row.mixte_ca)} bgClass="v2-bg-mixte" />
        </div>
        <div className="v2-pair">
          <DashboardV2MiniCard label="Total NB" value={formatDashboardNumber(row.total_nb)} bgClass="v2-bg-total" />
          <DashboardV2MiniCard label="Total CA" value={formatDashboardCa(row.total_ca)} bgClass="v2-bg-total" />
        </div>
      </div>
    </div>
  ));
};

export default DashboardV2PipeRows;
